<template>
  <div class="container py-4">
    <h2 class="text-center mb-3 font-weight-bold">
      Our Complete Service Offerings
    </h2>
    <p class="text-center text-muted mb-5">
      Expert garage door services backed by years of experience and guaranteed
      satisfaction
    </p>

    <div class="text-center mb-5">
      <button class="btn badge-pill border m-1">All Services (10)</button>
      <button class="btn badge-pill border m-1">Installation (1)</button>
      <button class="btn badge-pill border m-1">Repair (7)</button>
      <button class="btn badge-pill border m-1">Maintenance (1)</button>
      <button class="btn badge-pill border m-1">Emergency (1)</button>
    </div>

    <div class="row">
      <div
        class="col-md-6 col-lg-4 mb-4"
        v-for="(card, index) in cards"
        :key="index"
      >
        <div class="card border service-card shadow-sm h-100">
          <div class="card-body">
            <div class="icon-wrapper mb-3">
              <span v-html="card.icon"></span>
            </div>
            <div
              class="d-flex align-items-baseline justify-content-between mb-2"
            >
              <h5 class="font-weight-bold mb-0">{{ card.title }}</h5>
              <span class="py-2 badge-category">{{ card.category }}</span>
            </div>
            <p class="text-muted small">{{ card.description }}</p>
            <ul class="list-unstyled small text-muted">
              <li
                v-for="(feature, i) in card.features"
                :key="i"
                class="d-flex align-items-start mb-1"
              >
                <span class="mr-2" v-html="tickIcon"></span>
                <span>{{ feature }}</span>
              </li>
            </ul>
            <hr />
            <button
              @click="navigateToService(card)"
              class="btn badge-pill border d-flex justify-content-center w-100"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tickIcon: `
        <svg
          class="check-img"
          width="20"
          height="20"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 4C9.38442 4 4 9.38443 4 16C4 22.6156 9.38442 28 16 28C22.6156 28 28 22.6156 28 16C28 9.38443 22.6156 4 16 4ZM16 6C21.5347 6 26 10.4653 26 16C26 21.5347 21.5347 26 16 26C10.4653 26 6 21.5347 6 16C6 10.4653 10.4653 6 16 6ZM20.9492 12L14.6992 18.25L11.4492 15L10.0508 16.4004L14.6992 21.0508L22.3496 13.4004L20.9492 12Z"
            fill="#0d47a1"
          />
        </svg>`,
      cards: [
        {
          title: "New Garage Door Installations ",
          category: "Installation",
          slug: "new-garage-door-installations-residential-commercial",
          description:
            "Professional installation of high-quality residential and commercial garage doors with reliable warranty.",
          features: [
            "Wide selection of styles and materials",
            "Professional measuring and fitting",
            "Same-day installation available",
            "5-year warranty on installation",
          ],
          icon: `<svg width="30" height="30" fill="#0d47a1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2L2 7h20L12 2zm0 2.18L18.6 7H5.4L12 4.18zM4 9v11h16V9H4zm2 2h12v7H6v-7z"/></svg>`,
        },
        {
          title: "Replacement of Old or Damaged Doors",
          category: "Replacement",
          slug: "replacement-old-damaged-doors",
          description:
            "Complete door replacement services for worn, outdated, or nonfunctional garage doors.",
          features: [
            "Free inspection and estimate",
            "Energy-efficient solutions available",
            "Disposal of old doors included",
            "Updated safety features",
          ],
          icon: `<svg fill="#0d47a1" height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 490.922 490.922" xml:space="preserve"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M419.005,72.428C301.22-45.357,161.88,8.52,112.232,40.41L92.157,20.336c-5.725-5.725-14.305-7.434-21.77-4.324 c-7.439,3.08-12.316,10.34-12.307,18.443l0.031,88.262c0,5.502,2.242,10.488,5.85,14.098c3.617,3.617,8.607,5.861,14.102,5.854 l88.225-0.006c8.127,0.02,15.377-4.855,18.455-12.295c3.098-7.498,1.383-16.062-4.326-21.771l-9.877-9.877 c72.988-37.19,154.617-7.344,192.068,30.105c48.74,48.742,60.662,120.547,35.836,180.604l14.455,0.006 c15.963-0.004,30.994,6.221,42.299,17.525c5.957,5.957,10.395,12.984,13.371,20.605 C509.632,257.096,493.304,146.727,419.005,72.428z"></path> <path d="M412.88,349.307l-88.242-0.025c-8.109-0.02-15.375,4.869-18.457,12.303c-3.096,7.465-1.396,16.041,4.326,21.764 l9.877,9.877c-13.186,6.74-111.818,50.156-192.074-30.1c-48.736-48.736-60.65-120.523-35.84-180.582l-14.404-0.008 c-15.943,0.027-30.973-6.188-42.305-17.52c-5.969-5.969-10.422-13.024-13.395-20.678C-18.72,234.807-2.38,345.211,71.921,419.512 c55.902,55.902,132.193,78.625,205.127,69.426c50.215-6.332,89.965-29.609,101.781-37.268l19.938,19.938 c5.709,5.709,14.275,7.422,21.77,4.332c7.441-3.072,12.32-10.336,12.307-18.451V369.27c0.004-5.514-2.232-10.496-5.846-14.109 C423.38,351.543,418.394,349.303,412.88,349.307z"></path> <path d="M287.351,175.51c-2.504-6.064-8.416-10.037-15.004-10.037c0,0-0.029,0-0.049,0l-72.145,0.008 c-8.98,0.016-16.311,7.334-16.295,16.313v72.119c-0.016,6.621,3.959,12.557,10.029,15.068c2.037,0.832,4.148,1.242,6.266,1.242 c4.248,0,8.432-1.662,11.533-4.779l18.557-18.555l11.691,11.691l47.922,47.936c4.84,4.844,11.189,7.264,17.539,7.264 c6.344,0,12.693-2.42,17.539-7.264c9.686-9.684,9.686-25.391,0-35.08l-47.922-47.934l-11.693-11.695l18.496-18.498 C288.511,188.625,289.886,181.605,287.351,175.51z"></path> </g> </g></svg>`,
        },
        {
          title: "Broken Spring Replacement",
          category: "Repair",
          slug: "broken-spring-replacement",
          description:
            "Expert spring repair and replacement with high-quality springs built to last.",
          features: [
            "Emergency same-day service",
            "High-cycle springs available",
            "Safety inspection included",
            "Trained & certified technicians",
          ],
          icon: `<svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 398.089 398.089" xml:space="preserve" fill="#0d47a1"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path style="fill:#0d47a1;" d="M364.4,228.649c-4.487,0-8.129,3.633-8.129,8.129v145.054H41.826V236.777 c0-4.495-3.642-8.129-8.129-8.129s-8.129,3.633-8.129,8.129V389.96c0,4.495,3.642,8.129,8.129,8.129H364.4 c4.487,0,8.129-3.633,8.129-8.129V236.777C372.529,232.29,368.887,228.649,364.4,228.649z"></path> <path style="fill:#0d47a1;" d="M178.914,228.649H66.545c-4.487,0-8.129,3.633-8.129,8.129c0,4.495,3.642,8.129,8.129,8.129h104.241 v39.57c0,4.495,3.642,8.129,8.129,8.129h51.933c4.487,0,8.129-3.633,8.129-8.129v-39.57h92.576c4.487,0,8.129-3.633,8.129-8.129 c0-4.495-3.642-8.129-8.129-8.129H230.847c-4.487,0-8.129,3.633-8.129,8.129v39.57h-35.676v-39.57 C187.043,232.290,183.409,228.649,178.914,228.649z"></path> <path style="fill:#0d47a1;" d="M388.249,85.561H9.84c-4.487,0-8.129,3.633-8.129,8.129v112.369c0,4.495,3.642,8.129,8.129,8.129 h378.41c4.487,0,8.129-3.633,8.129-8.129V93.69C396.378,89.195,392.736,85.561,388.249,85.561z M380.121,197.931H17.968v-96.112 h362.152C380.121,101.819,380.121,197.931,380.121,197.931z"></path> <path style="fill:#0d47a1;" d="M283.683,67.061c4.487,0,8.129-3.633,8.129-8.129V8.129c0-4.495-3.642-8.129-8.129-8.129H114.414 c-4.487,0-8.129,3.633-8.129,8.129v50.804c0,4.495,3.642,8.129,8.129,8.129s8.129-3.633,8.129-8.129V16.257h153.012v42.675 C275.555,63.427,279.196,67.061,283.683,67.061z"></path> </g> </g></svg>`,
        },
        {
          title: "Cable Repair & Replacement",
          category: "Replacement",
          slug: "cable-repair-replacement",
          description:
            "Professional cable repair and replacement service to maintain smooth operation.",
          features: [
            "High-strength operation cables",
            "Complete system inspection",
            "Same-day service available",
            "1-year warranty on cables",
          ],
          icon: `<svg height="30px" width="30px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 300.458 300.459" xml:space="preserve" fill="#0d47a1"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#0d47a1;" d="M45.544,300.453L0,254.914l143.608-143.602l-7.262-7.265l21.985-82.057l82.065-21.986l11.87,11.885 l-26.108,26.108l7.674,28.633l28.642,7.676L288.583,48.2l11.876,11.879l-21.991,82.045l-82.06,21.988l-7.256-7.262L45.544,300.453 z M16.559,254.903l28.985,28.99l143.608-143.608l10.762,10.768l68.993-18.492l17.623-65.771l-20.562,20.57l-41.695-11.173 l-11.173-41.696l20.567-20.568l-65.774,17.623l-18.483,68.999l10.765,10.762L16.559,254.903z"></path> </g> </g> </g></svg>`,
        },
        {
          title: "Panel Replacement",
          category: "Replacement",
          slug: "panel-replacement",
          description:
            "Individual panel replacement to restore your garage door's exterior and functionality.",
          features: [
            "Cost-effective and quick solution",
            "Structural integrity assessment",
            "Weather seal replacement",
            "Visual match guarantee",
          ],
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" stroke="#0d47a1" fill="none" viewBox="0 0 24 24" stroke-width="2"><path d="M12 2L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-3z"></path></svg>`,
        },
        {
          title: "Roller and Hinge Repair",
          category: "Repair",
          slug: "roller-and-hinge-repair",
          description:
            "Expert repair of rollers and hinges for smooth and quiet garage door operation.",
          features: [
            "Noise reduction and lubrication",
            "Alignment and balance checks",
            "Durable replacement parts",
            "Extended hardware lifespan",
          ],
          icon: `<svg width="30" height="30" fill="#0d47a1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>ionicons-v5-q</title><path d="M262.29,192.31a64,64,0,1,0,57.4,57.4A64.13,64.13,0,0,0,262.29,192.31ZM416.39,256a154.34,154.34,0,0,1-1.53,20.79l45.21,35.46A10.81,10.81,0,0,1,462.52,326l-42.77,74a10.81,10.81,0,0,1-13.14,4.59l-44.9-18.08a16.11,16.11,0,0,0-15.17,1.75A164.48,164.48,0,0,1,325,400.8a15.94,15.94,0,0,0-8.82,12.14l-6.73,47.89A11.08,11.08,0,0,1,298.77,470H213.23a11.11,11.11,0,0,1-10.69-8.87l-6.72-47.82a16.07,16.07,0,0,0-9-12.22,155.3,155.3,0,0,1-21.46-12.57,16,16,0,0,0-15.11-1.71l-44.89,18.07a10.81,10.81,0,0,1-13.14-4.58l-42.77-74a10.8,10.8,0,0,1,2.45-13.75l38.21-30a16.05,16.05,0,0,0,6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16,16,0,0,0-6.07-13.94l-38.19-30A10.81,10.81,0,0,1,49.48,186l42.77-74a10.81,10.81,0,0,1,13.14-4.59l44.9,18.08a16.11,16.11,0,0,0,15.17-1.75A164.48,164.48,0,0,1,187,111.2a15.94,15.94,0,0,0,8.82-12.14l6.73-47.89A11.08,11.08,0,0,1,213.23,42h85.54a11.11,11.11,0,0,1,10.69,8.87l6.72,47.82a16.07,16.07,0,0,0,9,12.22,155.3,155.3,0,0,1,21.46,12.57,16,16,0,0,0,15.11,1.71l44.89-18.07a10.81,10.81,0,0,1,13.14,4.58l42.77,74a10.8,10.8,0,0,1-2.45,13.75l-38.21,30a16.05,16.05,0,0,0-6.05,14.08C416.17,247.67,416.39,251.83,416.39,256Z" style="fill:none;stroke:#0d47a1;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></path></g></svg>`,
        },
        {
          title: "Track Alignment and Repair",
          category: "Alignment",
          slug: "track-alignment-and-repair",
          description:
            "Precise track alignment and repair to ensure safe and efficient door movement.",
          features: [
            "Bent track straightening",
            "Full alignment service",
            "Rust prevention treatment",
            "Safety sensor recalibration",
          ],
          icon: `<svg width="30" height="30"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#0d47a1"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 7V12H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#0d47a1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`,
        },
        {
          title: "Opener Repair and Troubleshooting",
          category: "Troubleshooting",
          slug: "opener-repair-and-troubleshooting",
          description:
            "Comprehensive opener repair including motor, sensors, and control board issues.",
          features: [
            "Diagnostic testing included",
            "Genuine part replacements",
            "Remote programming",
            "Safety reverse feature check",
          ],
          icon: `<svg width="30" height="30" fill="#0d47a1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>ionicons-v5-q</title><path d="M262.29,192.31a64,64,0,1,0,57.4,57.4A64.13,64.13,0,0,0,262.29,192.31ZM416.39,256a154.34,154.34,0,0,1-1.53,20.79l45.21,35.46A10.81,10.81,0,0,1,462.52,326l-42.77,74a10.81,10.81,0,0,1-13.14,4.59l-44.9-18.08a16.11,16.11,0,0,0-15.17,1.75A164.48,164.48,0,0,1,325,400.8a15.94,15.94,0,0,0-8.82,12.14l-6.73,47.89A11.08,11.08,0,0,1,298.77,470H213.23a11.11,11.11,0,0,1-10.69-8.87l-6.72-47.82a16.07,16.07,0,0,0-9-12.22,155.3,155.3,0,0,1-21.46-12.57,16,16,0,0,0-15.11-1.71l-44.89,18.07a10.81,10.81,0,0,1-13.14-4.58l-42.77-74a10.8,10.8,0,0,1,2.45-13.75l38.21-30a16.05,16.05,0,0,0,6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16,16,0,0,0-6.07-13.94l-38.19-30A10.81,10.81,0,0,1,49.48,186l42.77-74a10.81,10.81,0,0,1,13.14-4.59l44.9,18.08a16.11,16.11,0,0,0,15.17-1.75A164.48,164.48,0,0,1,187,111.2a15.94,15.94,0,0,0,8.82-12.14l6.73-47.89A11.08,11.08,0,0,1,213.23,42h85.54a11.11,11.11,0,0,1,10.69,8.87l6.72,47.82a16.07,16.07,0,0,0,9,12.22,155.3,155.3,0,0,1,21.46,12.57,16,16,0,0,0,15.11,1.71l44.89-18.07a10.81,10.81,0,0,1,13.14,4.58l42.77,74a10.8,10.8,0,0,1-2.45,13.75l-38.21,30a16.05,16.05,0,0,0-6.05,14.08C416.17,247.67,416.39,251.83,416.39,256Z" style="fill:none;stroke:#0d47a1;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></path></g></svg>`,
        },
        {
          title: "Remote and Keypad Programming",
          category: "Repair",
          slug: "remote-and-keypad-programming",
          description:
            "Secure programming of remotes and keypads for easy and reliable access control.",
          features: [
            "Multi-device compatibility",
            "Secure code setup",
            "Battery replacement included",
            "User manual guidance",
          ],
          icon: `<svg width="30" height="30" fill="#0d47a1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><title>ionicons-v5-q</title><path d="M262.29,192.31a64,64,0,1,0,57.4,57.4A64.13,64.13,0,0,0,262.29,192.31ZM416.39,256a154.34,154.34,0,0,1-1.53,20.79l45.21,35.46A10.81,10.81,0,0,1,462.52,326l-42.77,74a10.81,10.81,0,0,1-13.14,4.59l-44.9-18.08a16.11,16.11,0,0,0-15.17,1.75A164.48,164.48,0,0,1,325,400.8a15.94,15.94,0,0,0-8.82,12.14l-6.73,47.89A11.08,11.08,0,0,1,298.77,470H213.23a11.11,11.11,0,0,1-10.69-8.87l-6.72-47.82a16.07,16.07,0,0,0-9-12.22,155.3,155.3,0,0,1-21.46-12.57,16,16,0,0,0-15.11-1.71l-44.89,18.07a10.81,10.81,0,0,1-13.14-4.58l-42.77-74a10.8,10.8,0,0,1,2.45-13.75l38.21-30a16.05,16.05,0,0,0,6-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16,16,0,0,0-6.07-13.94l-38.19-30A10.81,10.81,0,0,1,49.48,186l42.77-74a10.81,10.81,0,0,1,13.14-4.59l44.9,18.08a16.11,16.11,0,0,0,15.17-1.75A164.48,164.48,0,0,1,187,111.2a15.94,15.94,0,0,0,8.82-12.14l6.73-47.89A11.08,11.08,0,0,1,213.23,42h85.54a11.11,11.11,0,0,1,10.69,8.87l6.72,47.82a16.07,16.07,0,0,0,9,12.22,155.3,155.3,0,0,1,21.46,12.57,16,16,0,0,0,15.11,1.71l44.89-18.07a10.81,10.81,0,0,1,13.14,4.58l42.77,74a10.8,10.8,0,0,1-2.45,13.75l-38.21,30a16.05,16.05,0,0,0-6.05,14.08C416.17,247.67,416.39,251.83,416.39,256Z" style="fill:none;stroke:#0d47a1;stroke-linecap:round;stroke-linejoin:round;stroke-width:32px"></path></g></svg>`,
        },

        {
          title: "Fast Response for Stuck or Non-Functioning Doors",
          category: "Emergency",
          slug: "emergency-stuck-doors",
          description:
            "Immediate emergency response for garage doors that stop working unexpectedly.",
          features: [
            "24/7 emergency support",
            "On-the-spot repairs",
            "Quick diagnosis",
            "One-hour response time",
          ],
          icon: `<svg width="30" height="30"  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 7V12H15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#0d47a1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>`,
        },
      ],
    };
  },
  methods: {
    navigateToService(service) {
      const currentPath = this.$route.path;

      let city = null;
      if (currentPath.includes("/service-areas/")) {
        city = currentPath.split("/service-areas/")[1];
      }

      let slug = service.slug;
      if (city) {
        slug = `${slug}-in-${city}`;
      }
      this.$router.push(`/services/${slug}`);
    },

    // Alternative method for creating URL-friendly slugs if you don't want to predefine them
    createSlug(title) {
      return title
        .toLowerCase()
        .replace(/[^\w ]+/g, "")
        .replace(/ +/g, "-");
    },
  },
};
</script>

<style>
.service-card {
  transition: all 0.3s ease-in-out;
  border-radius: 1rem !important;
}
.service-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
}
.check-img {
  flex-shrink: 0;
}
.badge-pill {
  transition: all 0.3s ease;
  cursor: pointer;
}
.badge-pill:hover {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: white !important;
  transform: scale(1.05);
}
.badge-category {
  background-color: #000000;
  color: #fff;
  padding: 14px 15px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 12px;
}
.icon-wrapper {
  width: 60px;
  height: 60px;
  background-color: #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
@media (max-width: 768px) {
  h2 {
    font-size: 25px !important;
  }
}
</style>
